// extracted by mini-css-extract-plugin
export default {"root":"vstack_root__Ta5Rj","leading":"vstack_leading__bHZfy","center":"vstack_center__gZWha","trailing":"vstack_trailing__37W3d"};